import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import AppManager from "../../../managers/AppManager";
import {
    DKLabel,
    DKLine,
    DKButton,
    showLoader,
    removeLoader,
    DKInput,
    INPUT_TYPE,
    INPUT_VIEW_DIRECTION,
    showToast,
    TOAST_TYPE
} from "deskera-ui-library";
import ic_document from "../../../assets/icons/ic_document.png";
import Table from "../../../services/table";
import { COUNTRY } from "../../../constants/CountryConstant";
import USComplianceService from "../../../services/compliance/US/USComplianceService";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import ProfileSetupService from "../../../services/ProfileSetup-service";
import { PROFILE_STAGES_CONSTANT } from "../../../constants/Constant";
import TenantManager from "../../../managers/TenantManager";
import SignForm from "./SignForm";
import Utility from "../../../utility/Utility";
import { async } from "rxjs";

function FillingAuthorization(props) {
    const history = useHistory();
    const { t } = useTranslation();

    const [forms, setForms] = useState([]);

    const [signatoryName, setSignatoryName] = useState({
        id: "signerName",
        title: t("NAME"),
        type: INPUT_TYPE.TEXT,
        validation: [["required"]],
        value: TenantService.get(TENANT.FULL_NAME),
        readOnly: !TenantService.get(TENANT.IS_ADMIN)
    });

    const [signatoryTitle, setSignatoryTitle] = useState({
        id: "signerTitle",
        title: t("JOB_TITLE"),
        type: INPUT_TYPE.TEXT,
        validation: [["required"]],
        value: TenantService.get(TENANT.DESIGNATION),
        readOnly: !TenantService.get(TENANT.IS_ADMIN)
    });

    const [signatoryEmail, setSignatoryEmail] = useState({
        id: "email",
        title: t("EMAIL"),
        type: INPUT_TYPE.EMAIL,
        validation: [["required"]],
        value: TenantService.get(TENANT.EMAIL_ID),
        readOnly: !TenantService.get(TENANT.IS_ADMIN)
    });

    const [showForm, setShowForm] = useState(false);
    const [isAllSigned, setIsAllSigned] = useState(false);

    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();

        getAuthFormsAndFormDetails();
    }, []);

    const getAuthFormsAndFormDetails = async () => {
        showLoader();
        if(TenantService.get(TENANT.IS_ADMIN)) {
            await getAuthFormsFromAPI(Table.getStateFormsAndFields(COUNTRY.US, TenantService.get(TENANT.STATE_CODE)))
        } else {
            await getAuthFormsFromAPI(Table.getStateFormsAndFieldsEmployee(COUNTRY.US, TenantService.get(TENANT.STATE_CODE)))
        }
        removeLoader();
    }
    const getAuthFormsFromAPI = async(apis) => {
        await Promise.all([apis, USComplianceService.getFormData()]).then(
            (response) => {
                const stateConfig = response[0];
                const formData = response[1];
        
                const authForms = TenantService.get(TENANT.IS_ADMIN) ? 
                stateConfig?.authForms : stateConfig?.employeeForms;
                if (authForms?.length > 0) {
                    let forms = authForms;
                    if (formData?.data?.length > 0) {
                        forms = authForms.map((f) => {
                            const data = formData.data.find((d) => d.form === f.id);
                            if (data) {
                                return {
                                    ...f,
                                    ...data
                                };
                            } else {
                                return f;
                            }
                        });
                    }
        
                    const unsignedIndex = forms.findIndex((f) => f.stage !== "SIGNED");
                    if (unsignedIndex === -1) {
                        setIsAllSigned(true);
                        updateStateOfProfileStage();
                    }
        
                    setForms(forms);
                }
            }, (error) => {
                showToast(t("INTERNAL_SERVER_ERROR"), TOAST_TYPE.FAILURE);
            }
        );
    }

    const updateStateOfProfileStage = () => {
        ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.FILLING_AUTH).then(
            (response) => {
                if (TenantService.get(TENANT.IS_ADMIN)) {
                    TenantManager.setProfileData(response['profileStages']);
                } else {
                    TenantService.set(TENANT.EMPLOYEE_PROFILE_STAGES, response?.user?.profileStages);
                }
            }
        );
    }

    const isRequired = (validation) => {
        return validation ? validation.findIndex((v) => v[0] === "required") !== -1 : false;
    }

    const hasError = (field, value) => {
        let error = {
            invalid: false,
            errorMessage: null
        };

        const validation = field.validation;

        if (validation && validation.length !== 0) {
            for (let v of validation) {
                switch (v[0]) {
                    case "required":
                        if (value === null || value === undefined || String(value).trim() === "") {
                            error.invalid = true;
                        }
                        break;
                    default:
                        error.invalid = false;
                        error.errorMessage = null;
                        break;
                }

                if (error.invalid) {
                    break;
                }
            }
        }

        return error;
    }

    const isValidSignatory = () => {
        let isValid = false;
        const invalidFields = [];

        const sections = {
            signatoryName: signatoryName,
            signatoryTitle: signatoryTitle,
            signatoryEmail: signatoryEmail
        };

        Object.entries(sections).forEach(([key, state]) => {
            const field = {...state};
            const error = hasError(field, field.value);
            field.invalid = error.invalid;
            field.errorMessage = error.errorMessage;

            if (!field.invalid) {
                isValid = true;
            } else {
                invalidFields.push(field.id); 
            }

            switch (key) {
                case "signatoryName":
                    setSignatoryName(field);
                    break;
                case "signatoryTitle":
                    setSignatoryTitle(field);
                    break;
                case "signatoryEmail":
                    setSignatoryEmail(field)
                    break;
                default:
                    break;
            }
        });

        return Utility.isEmpty(invalidFields.length);
    }

    const getSignatoryDetails = () => {
        return {
            signerName: signatoryName.value,
            signerTitle: signatoryTitle.value,
            email: signatoryEmail.value,
            employeeId: TenantService.get(TENANT.USER_ID)
        };
    }

    const renderField = (field, setState, width) => {
        switch (field.type) {
            case INPUT_TYPE.TEXT:
            case INPUT_TYPE.EMAIL:
                return (
                    <div key={field.id} style={{ flex: `${width}`, maxWidth: width }}>
                        <div className="row pb-l mb-s position-relative">
                            <DKInput
                                title={field.title}
                                type={field.type}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                value={field.value}
                                errorMessage={field.errorMessage}
                                readOnly={!!field.readOnly}
                                required={isRequired(field.validation)}
                                tooltip={{
                                    content: field.tooltip,
                                    className: "warning-tooltip-prop"
                                }}
                                invalid={field.invalid}
                                canValidate={field.invalid}
                                onChange={(value) => {
                                    setState({
                                        ...field,
                                        value: value,
                                        ...hasError(field, value)
                                    });
                                }}
                                validator={field.validator}
                            />
                        </div>
                    </div>
                );
            default:
                break;
        }
    }

    const renderHeaderForStep = () => {
        return (
            <div className="row justify-content-between p-h-xxl p-v-m bg-gray2">
                <DKLabel text={t("FILL_AUTH")} className="fs-l fw-m" />
                <DKButton
                    title={"Close"}
                    className="border-m bg-white ml-auto"
                    onClick={() => {
                        props.onClose();
                    }}
                />
                <DKButton
                    title={"Save & Next"}
                    className="border-m bg-app text-white ml-m"
                    onClick={() => {
                        if (!isAllSigned) {
                            showToast(t("SIGN_ALL_FORM"), TOAST_TYPE.FAILURE);
                            return;
                        }
                        const unsignFormIndex = forms.findIndex(f=>f.stage !== "SIGNED" );
                        if(unsignFormIndex === -1) {
                            props.onSaveAndNext();
                            updateStateOfProfileStage();
                        }
                    }}
                />
            </div>
        )
    }

    const renderSignatoryFields = () => {
        return (
            <div className="row p-h-xxl pt-l pb-s justify-content-between">
                {renderField(signatoryName, setSignatoryName, "30%")}
                {renderField(signatoryTitle, setSignatoryTitle, "30%")}
                {renderField(signatoryEmail, setSignatoryEmail, "30%")}
            </div>
        );
    }

    const renderFillingAuth = () => {
        return (
            <div className={`parent-width ${props.renderAsStep ? "pb-m" : "p-v-m"}`}>
                {(!props.renderAsStep || (!TenantService.get(TENANT.IS_ADMIN) && !props.renderAsStep)) &&
                    <Fragment>
                        <DKLabel text={t("AUTHORIZATION_FORMS")} className="fs-l fw-b mb-s" />
                        <DKLabel text={t("AUTHORIZATION_FORMS_TEXT")} className="text-gray" />
                    </Fragment>
                }
                <div className={`bg-white border-radius-m ${!props.renderAsStep && "mt-xl"}`}>
                    <div className="row p-h-xxl">
                        <DKLabel text={t("SIGNATORY_DETAILS")} className="fs-l fw-m pt-l pb-s" />
                    </div>
                    <DKLine className="bg-line-2" />
                    {renderSignatoryFields()}
                </div>
                <div className={`bg-white border-radius-m ${!props.renderAsStep && "mt-xl"}`}>
                    <DKLabel text={t("AUTHORIZATION_FORMS")} className="fs-l fw-b p-h-xxl pt-l pb-s" />
                    <DKLine className="bg-line-2" />
                    <div className="p-h-l pt-s pb-l">
                        {forms.map((form, index) => {
                            return (
                                <div className={`row ${index !== 0 ? "pt-s" : ""}`}>
                                    <DKButton
                                        icon={ic_document}
                                        title={form.name}
                                        className="fs-l text-gray cursor-hand"
                                        onClick={() => {
                                            if (isValidSignatory()) {
                                                USComplianceService.FORM = {
                                                    ...form,
                                                    signatory: getSignatoryDetails()
                                                };

                                                if (props.renderAsStep) {
                                                    setShowForm(true);
                                                } else {
                                                    RouteManager.navigateToPage(PAGE_ROUTES.SIGN_FORM);
                                                }
                                            }
                                        }}
                                    />
                                    {form.stage === "SIGNED" && <div class="bg-chip-green text-green p-v-s p-h-r border-radius-l fw-m text-wrap-none m-s fs-s">{t("SIGNED")}</div>}
                                    {form.stage !== "SIGNED" && <div class="bg-chip-orange text-orange p-v-s p-h-r border-radius-l fw-m text-wrap-none m-s fs-s">{t("UNSIGNED")}</div>}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Fragment>
            {props.renderAsStep && renderHeaderForStep()}
            {!showForm &&
                <Fragment>
                    {renderFillingAuth()}
                </Fragment>
            }
            {showForm &&
                <SignForm
                    {...props}
                    renderAsStep={props.renderAsStep}
                    onBack={(refresh) => {
                        setShowForm(false);
                        if (refresh) {
                            getAuthFormsAndFormDetails();
                        }
                    }}
                />
            }
        </Fragment>
    );
}

export default FillingAuthorization;
